// src/modules/LiberacoesFinanceiras/services/pixPaymentService.js
import { fetchData } from '../../../utils/datasource';

/**
 * Fetches all pending payments
 * @returns {Promise<Array>} Array of payment objects
 * @throws {Error} If the API request fails
 */
export const fetchPayments = async () => {
  console.log('Fetching payments from /sibeapp/liberafin/pix/');
  
  try {
    const response = await fetchData(
      '/sibeapp/liberafin/pix/',
      'GET',
      {},
      30000
    );

    console.log('Payments response:', response);

    if (!response.ok) {
      throw new Error('Failed to fetch payments');
    }

    const result = await response.json();
    console.log('Parsed result:', result);

    if (result.status !== 'ok') {
      throw new Error('Failed to fetch payments');
    }

    // Map API fields to expected format
    const payments = result.data.map(item => ({
      E2_FILIAL: item.FILIAL,
      E2_FILORIG: item.FILORIG,
      E2_TIPO: item.TIPO,
      E2_FORNECE: item.FORNECE,
      E2_LOJA: item.LOJA,
      E2_PREFIXO: item.PREFIXO,
      E2_NUM: item.NUM,
      E2_PARCELA: item.PARCELA,
      E2_NOMFOR: item.NOMFOR,
      E2_VENCREA: item.VENCREA,
      E2_EMISSAO: item.EMISSAO,
      E2_SALDO: item.SALDO,
      E2_RECNO: item.RECNO,
      A2_NOME: item.A2_NOME,
      A2_XCHVPIX: item.A2_XCHVPIX,
      A2_XTPCPIX: item.A2_XTPCPIX,
      E2_XIDPIX: item.E2_XIDPIX,
      E2_XNOMPI: item.E2_XNOMPI,
      E2_XPIXBC: item.E2_XPIXBC,
      E2_XPIXIS: item.E2_XPIXIS,
      E2_XPIXDC: item.E2_XPIXDC
    }));

    console.log('Mapped payments:', payments);
    return payments;
  } catch (error) {
    console.error('Error fetching payments:', error);
    throw error;
  }
};

/**
 * Authorizes a payment by sending all required parameters via query string
 * @param {Object} payment - Payment object with all required fields
 * @returns {Promise<Object>} Response from the API
 * @throws {Error} If the API request fails
 */
export const authorizePayment = async (payment) => {
  console.log('Authorizing payment:', payment);



  try {
    // Build query parameters for PIX
    // const queryParams = new URLSearchParams({
    //   E2FILIAL: payment.E2_FILIAL || '',
    //   E2PREFIXO: payment.E2_PREFIXO || '',
    //   E2NUM: payment.E2_NUM || '',
    //   E2PARCELA: payment.E2_PARCELA || '',
    //   E2SALDO: payment.E2_SALDO || '',
    //   E2NOMFOR: payment.E2_NOMFOR || '',
    //   E2RECNO: payment.E2_RECNO || '',
    //   A2NOME: payment.A2_NOME || '',
    //   A2XCHVPIX: payment.A2_XCHVPIX || '',
    //   A2XTPCPIX: payment.A2_XTPCPIX || '',
    //   E2XIDPIX: payment.E2_XIDPIX || '',
    //   E2XNOMPI: payment.E2_XNOMPI || '',
    //   E2XPIXBC: payment.E2_XPIXBC || '',
    //   E2XPIXIS: payment.E2_XPIXIS || '',
    //   E2XPIXDC: payment.E2_XPIXDC || ''
    // }).toString();

     const queryParams = new URLSearchParams({
       XUUID: payment.E2_XIDPIX || '',
       XVALDDA: payment.E2_SALDO || '',
       E2FILIAL: payment.E2_FILIAL || '',
       E2PREFIXO: payment.E2_PREFIXO || '',
       E2NUM: payment.E2_NUM || '',
       E2PARCELA: payment.E2_PARCELA || '',
       E2TIPO: payment.E2_TIPO || '',
       E2FORNECE: payment.E2_FORNECE || '',
       E2LOJA: payment.E2_LOJA || '',
       E2NOMFOR: payment.E2_NOMFOR || '',
       E2FILORIG: payment.E2_FILORIG || ''
       
     }).toString();    

    const url = `/sibeapp/liberafin/pix/autorizar?${queryParams}`;
    console.log('### url:');
    console.log(url);
    console.log('### payment:');
    console.log(payment)
    
    const response = await fetchData(
      url,
      'POST',
      {},
      30000
    );

    console.log('Authorization response:', response);

    if (!response.ok) {
      throw new Error('Failed to authorize payment');
    }

    const result = await response.json();
    console.log('Authorization result:', result);

    return result;
  } catch (error) {
    console.error('Error authorizing payment:', error);
    throw error;
  }
};

/**
 * Updates payment status
 * @param {string} numero - Payment number
 * @returns {Promise<Object>} Response from the API
 * @throws {Error} If the API request fails
 */
export const updatePaymentStatus = async (numero) => {
  console.log('Updating payment status for numero:', numero);

  // Mock success response
  await new Promise(resolve => setTimeout(resolve, 500));
  return { status: 'ok', message: 'Payment status updated successfully' };
  
};
